export default "__VITE_ASSET__ByQlebN$__"